import React, { useState, useCallback, useEffect } from "react";
import { FormLayout, TextField, Modal, Toast, Text } from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import instructionImg from "../Assets/Images/instruction-help.svg";
import instructionEdit from "../Assets/Images/instruction-edit.svg";
const Instruction = (props) => {
  const [activeToast, setActiveToast] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const toastMarkup = activeToast ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActiveToast}
    />
  ) : null;
  const [instructionValue, setInstructionValue] = useState(props.text);
  const handleChangeInstruction = useCallback(
    (newValue) => setInstructionValue(newValue),
    []
  );
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);
  const handleSubmit = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("instructions", instructionValue);
    form_data.append("_method", "PATCH");
    axios
      .post(
        `/pages/${props.pageId}/sections/${props.sectionId}/instructions/update`,
        form_data
      )
      .then((res) => {
        setInstructionValue("");
        setIsSaving(false);
        setActive(false);
        toggleActiveToast();
        props.handleRefreshSections();
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    setInstructionValue(props.text);
  }, [props.text]);

  return (
    <FormLayout>
      <div
        className="rowDiv"
        style={{ cursor: "pointer" }}
        onClick={() => setActive(true)}
      >
        <img src={instructionImg} width={17} className="me-2" />
        <Text as="p" color="subdued">
          {props.text
            ? props.text
            : "No instruction added. Click on the icon to add a new one."}
        </Text>
        {/* <img src={instructionEdit} width={17} className="ms-2" /> */}
      </div>
      <Modal
        open={active}
        onClose={handleChange}
        title="Edit Instruction"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChange,
          },
        ]}
      >
        <Modal.Section>
          <TextField
            label="Instruction"
            value={instructionValue}
            onChange={handleChangeInstruction}
            multiline={5}
          />
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </FormLayout>
  );
};

export default Instruction;
